import React from 'react';
import { emergencyCancelRide } from '../../services/adminService';
import toast from 'react-hot-toast';

export const ActiveRideFeed = ({ rides, onCancel }) => {
  const handleCancel = async (rideId) => {
    const confirmed = window.confirm('?? EMERGENCY CANCEL: This action cannot be undone. Are you absolutely sure?');
    if (!confirmed) return;
    const reason = prompt('Reason for emergency cancellation:');
    if (!reason) return;
    try {
      await emergencyCancelRide(rideId, reason);
      toast.success('Ride cancelled');
      if (onCancel) onCancel(rideId);
    } catch (err) {
      toast.error(err.message);
    }
  };

  return (
    <div className="bg-gray-800 rounded-lg p-4">
      <h3 className="font-semibold mb-3">Active Rides</h3>
      <div className="space-y-2 max-h-96 overflow-y-auto">
        {rides.map(ride => (
          <div key={ride.id} className="border border-gray-700 rounded-lg p-3 hover:bg-gray-750 transition-colors">
            <div className="flex justify-between items-start">
              <div>
                <div className="flex items-center space-x-2">
                  <span className="font-mono text-xs text-gray-400">{ride.id.slice(-6)}</span>
                  <span className={`px-2 py-0.5 text-xs rounded-full ${
                    ride.status === 'pending' ? 'bg-yellow-900 text-yellow-300' : 'bg-blue-900 text-blue-300'
                  }`}>{ride.status}</span>
                </div>
                <div className="text-sm mt-1">
                  <span className="text-gray-400">Rider:</span> {ride.userId?.slice(-6) || 'N/A'}
                </div>
                <div className="text-sm">
                  <span className="text-gray-400">Driver:</span> {ride.driverId?.slice(-6) || 'Unassigned'}
                </div>
                <div className="text-sm">
                  <span className="text-gray-400">Fare:</span> R{(ride.estimatedFareCents / 100).toFixed(2)}
                </div>
              </div>
              <button
                onClick={() => handleCancel(ride.id)}
                className="text-red-400 hover:text-red-300 text-xs bg-red-950/50 px-2 py-1 rounded"
              >
                Emergency Cancel
              </button>
            </div>
          </div>
        ))}
        {rides.length === 0 && <p className="text-gray-500 text-center">No active rides</p>}
      </div>
    </div>
  );
};
